//#region Styles
import { Column, Row, TitleSection } from "components/styles";
import { AboutSchedule, Container, Content, ScheduleCard } from "../styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import { CustomRadio } from "components/CustomRadio/CustomRadio";
import DialogAlert from "components/DialogAlert/DialogAlert";
import CloseButton from "components/CloseButton/CloseButton";
import { getTextByRangeMinutes } from "components/CustomTimePicker/utils";
import { MONTHS, WEEK_DAYS } from "components/CustomDatePicker/utils/helpers";
//#endregion
//#region Icons
import LocationIcon from "icons/LocationIcon";
import RemoteIcon from "icons/RemoteIcon";
import TimerIcon from "icons/TimerIcon";
import CalendarIcon from "icons/CalendarIcon";
//#endregion
//#region Services
import { requestReassignUpcomingSchedule } from "services/appointment/aboutAppoinment";
//#endregion
//#region Utils
import { LOADING_MESSAGES } from "../../Popups/constants";
import useMainContext from "utils/context/useMainContext";
//#endregion

const getFormattedDate = timestamp => {
    const dateObj = new Date(timestamp)
    const dayName = WEEK_DAYS[dateObj.getDay()].substring(0, 3);
    const monthName = MONTHS[dateObj.getMonth()].substring(0, 3);
    return `${dayName}, ${dateObj.getDate()} ${monthName} ${dateObj.getFullYear()}`;
}

const DialogUpcomingSchedulesReassignment = ({
    show, toggleShow, setLoadingService,
    toggleShowDialogUpcomingSuccessfulReassignment,
    schedules, reservation, currentSchedule,
    setCurrentUpcomingSchedule,
    isPresential
}) => {
    const mainContext = useMainContext();
    //#region States
    //#endregion
    //#region Functions
    const reassignSchedule = async () => {
        toggleShow(false);
        const newLoadingService = {
            loading: true,
            message: LOADING_MESSAGES.UPDATE
        };
        setLoadingService({ ...newLoadingService });
        const success = await requestReassignUpcomingSchedule({
            reservationId: reservation.id, 
            appointmentDateId: currentSchedule.appointmentDateId, 
            timeStart: currentSchedule.time.start
        });
        setLoadingService({ ...newLoadingService, loading: false });
        // Verificando si la reasignación se completo con éxito
        if (success) toggleShowDialogUpcomingSuccessfulReassignment();
        else mainContext.setShowDialogUnexpectedError(true);
    }
    //#endregion
    return (
        <DialogAlert 
            show={show} 
            toggleShow={toggleShow}
            close={() => toggleShow(false)}
            variant="reassignment">
            <CloseButton onClick={() => toggleShow(false)}/>
            <Column align="center" 
                gap="24px"
                marginTop="46px">
                <TitleSection 
                    width="100%"
                    textAlign="center" 
                    fontWeight="900" 
                    margin="0">Horarios disponibles más cercanos</TitleSection>
                <Container>
                    <Content>
                        {schedules.map((props, idx) => {
                            const { time, date, ...restProps } = props;
                            const timeStr = getTextByRangeMinutes(time);
                            const dateStr = getFormattedDate(date);
                            const checked = props.appointmentDateId === currentSchedule.appointmentDateId && props.time === currentSchedule.time;
                            return (
                                <ScheduleItem 
                                    key={idx}
                                    {...restProps}
                                    timeStr={timeStr}
                                    dateStr={dateStr}
                                    checked={checked}
                                    isPresential={isPresential}
                                    onChange={() => setCurrentUpcomingSchedule({
                                        ...props,
                                        dateStr, timeStr
                                    })}/>
                            );
                        })}
                    </Content>
                </Container>
                <Row width="100%" justifyContent="center" gap="16px">
                    <CustomButton 
                        variant="secondary" 
                        size="medium" 
                        width="87px"
                        text="Cancelar"
                        onClick={() => toggleShow(false)}/>
                    <CustomButton 
                        size="medium" 
                        width="82px"
                        text="Agregar"
                        onClick={reassignSchedule}/>
                </Row>
            </Column>
        </DialogAlert>
    );
}

const ScheduleItem = ({
    checked,
    onChange,
    isPresential,
    adviser,
    dateStr, timeStr
}) => {
    return (
        <ScheduleCard>
            <CustomRadio 
                label={adviser.name}
                checked={checked}
                onChange={onChange}
                fontSizeLabel="14px"/>
            <AboutSchedule>
                {isPresential 
                ? <Row gap="7px">
                    <LocationIcon size={18}/>
                    <span>Lugar</span>
                </Row>
                : <Row gap="7px">
                    <RemoteIcon size={16}/>
                    <span>Zoom</span>
                </Row>}
                <Row gap="7px">
                    <CalendarIcon size={16}/>
                    <span>{dateStr}</span>
                </Row>
                <Row gap="7px">
                    <TimerIcon size={16}/>
                    <span>{timeStr}</span>
                </Row>
            </AboutSchedule>
        </ScheduleCard>
    );
}

export default DialogUpcomingSchedulesReassignment;
